import { selectAccount } from 'ducks/accounts/selectors/selectAccount'

// The Helply account id for this Groove account. IMPORTANT: the Groove
// subdomain is NOT the Helply account slug, so the copilot must key off the
// Helply account id explicitly (the grant carries it, and Helply's /auth
// resolves the account by id).
//
// TEMP(dev): read it from localStorage until the Groove backend includes it on
// the bootstrapped account payload from groove-provision. Set it for local
// testing with:
//   localStorage.setItem('helply_account_id', '<helply-account-uuid>')
// Once the backend ships, prefer `account.helply_account_id` and drop the
// localStorage fallback.
export const selectHelplyAccountId = state => {
  const account = selectAccount(state)
  if (account.helply_account_id) return account.helply_account_id
  try {
    return localStorage.getItem('helply_account_id') || null
  } catch (e) {
    return null
  }
}
